import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("DIY Card", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
}, { additionalProperties: true }));
